import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NativeAudioService {

  private webAudio: HTMLAudioElement;

  constructor() {
    // this.webAudio = new Audio('assets/audios/turn_arrived.mp3'); //
    this.webAudio = new Audio('../../../assets/audios/turn_arrived.mp3');
    this.webAudio.load();
  }

  public playNewTurnSound(): void {
    if (window.Android && typeof window.Android.playTurnSound === 'function') {
      console.log('Playing sound via Android native interface...');
      window.Android.playTurnSound();
    } else {
      console.log('Playing sound via web audio fallback...');
      this.webAudio.currentTime = 0;
      this.webAudio.play().catch(error => {
        console.warn('Web audio playback was blocked by the browser. A user interaction is required to enable it.', error);
      });
    }
  }
}
